@if (hero()) {
  <app-avatar
    class="avatar"
    [avatarType]="avatarType()"
    [ngLevel]="hero().ngLevel || 0"
    [level]="hero().stats.level"
    [imagePath]="avatarUrl()"
    [experience]="hero().stats.experience"
    [routerLink]="MAIN_ROUTES.CHAR" />

  @if (heroAttributes()) {
    <div
      class="attrs g-flex-column g-flex--align-start"
      [class.max-width-420]="!isLongCard()"
      [class.width-100-percent]="isLongCard()"
      [class.g-flex--space-between]="isLongCard()"
      [class.margin-left-30]="isLongCard()"
      [class.margin-right-50]="isLongCard()">
      <div
        class="name g-flex g-flex--align-center gap-8 width-100-percent"
        [class.max-width-420]="isLongCard()">
        <app-life-chances
          class="g-flex__item-fixed"
          imageWidth="80px"
          [lifeChance]="hero().stats.lifeChances" />

        <div class="g-flex__item title-a color-nickname text-shadow app-btn-medium_font-size text-ellipsis text-center">
          {{ hero().uniqName }}
        </div>

        @if (heroState()) {
          <img
            class="g-flex__item-fixed"
            height="60"
            [src]="'assets/images/ui/icons/stage/' + heroState() + '.png'"
            alt="hero-state"
            (click)="onShowStateDialog()" />
        }
      </div>

      <div
        [class.g-flex-column]="!isLongCard()"
        [class.g-flex]="isLongCard()"
        [class.gap-8]="!isShowItems()"
        [class.width-100-percent]="isLongCard()"
        [class.g-flex--space-between]="isLongCard()"
        [class.g-flex--align-center]="isShowKarma()">
        <div class="g-flex-column">
          <app-bar-stat
            barType="hp"
            size="medium"
            [isShowBarName]="isShowBarName()"
            [percentageValue]="hero().stats.life / heroAttributes()!.life"
            [label]="hero().stats.life + ' / ' + heroAttributes()!.life" />

          <app-bar-stat
            barType="mp"
            size="medium"
            [isShowBarName]="isShowBarName()"
            [percentageValue]="hero().stats.mana / heroAttributes()!.mana"
            [label]="hero().stats.mana + ' / ' + heroAttributes()!.mana" />

          @if (isShowExpBar()) {
            <app-bar-stat
              barType="exp"
              size="medium"
              [isShowBarName]="isShowBarName()"
              [percentageValue]="expBarWidth()"
              [label]="heroExpPercent() >= 100 ? 'up to ' + virtualLevel() + ' level' : heroExpPercent() + ' %'">
            </app-bar-stat>
          }
        </div>

        @if (isShowKarma()) {
          <div class="karma g-flex-column app-btn-huge_font-size title-a">
            <div class="karma__title">Reputation:</div>

            <div class="hero-title color-caption g-flex g-flex--align-center gap-20">
              <div>{{ heroTitle() }} ({{ karma() }})</div>

              <img
                class="hero-title__info"
                src="/assets/images/ui/icons/other/info-holder-question.png"
                alt=""
                (click)="onShowHeroTitleDialog()" />
            </div>
          </div>
        }

        @if (isShowItems()) {
          <div
            class="slots"
            [class.g-flex-column]="isLongCard()"
            [class.g-flex]="!isLongCard()"
            [class.g-flex--align-center]="!isLongCard()"
            [class.g-flex--space-between]="!isLongCard()"
            [class.margin-top-8]="!isLongCard()"
            [class.slots--long]="isLongCard()">
            <div class="g-flex g-flex--wrap g-flex--align-center g-flex--justify-center gap-10 width-240">
              @for (itemSlot of heroItemsBody; track itemSlot; let i = $index) {
                <app-item-slot
                  class="item-slot g-flex"
                  [class.pointer]="hero().items[i]"
                  [slotItem]="getHeroItem(itemSlot)"
                  [slotIcon]="
                    itemSlot[0] !== ITEM_SLOT.SKILL_1 &&
                    itemSlot[0] !== ITEM_SLOT.SKILL_2 &&
                    itemSlot[0] !== ITEM_SLOT.SKILL_3
                      ? getSlotIcon(heroItemSlotTypes[i])
                      : undefined
                  "
                  [clickOnItemImg]="true"
                  slotSize="small"
                  (clickEmit)="
                    getHeroItem(itemSlot)
                      ? openItemDescriptionDialog(getHeroItem(itemSlot))
                      : canClickItem()
                        ? openItemInfoDialog()
                        : null
                  ">
                </app-item-slot>
              }
            </div>

            <div class="g-flex g-flex--wrap g-flex--align-center g-flex--justify-center gap-10">
              @for (itemSlot of heroItemsSkills; track itemSlot; let i = $index) {
                <div class="skill">
                  <app-item-slot
                    class="item-slot g-flex"
                    [class.pointer]="hero().items[i]"
                    [slotItem]="getHeroItem(itemSlot)"
                    [slotIcon]="
                      itemSlot[0] !== ITEM_SLOT.SKILL_1 &&
                      itemSlot[0] !== ITEM_SLOT.SKILL_2 &&
                      itemSlot[0] !== ITEM_SLOT.SKILL_3
                        ? getSlotIcon(heroItemSlotTypes[i])
                        : undefined
                    "
                    [clickOnItemImg]="true"
                    slotSize="small"
                    (clickEmit)="
                      getHeroItem(itemSlot)
                        ? openItemDescriptionDialog(getHeroItem(itemSlot))
                        : canClickItem()
                          ? openItemInfoDialog()
                          : null
                    ">
                  </app-item-slot>

                  <img
                    class="skill__icon"
                    src="assets/images/ui/icons/item-props/skill-medium.png"
                    alt="skill-icon" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (isShowBg()) {
    <div class="bg"></div>
  }
}
